import TtamAppEventExternalActionSelect from './external-action-select/index.vue';
import TtamAppEventAllEventsInactiveTips from './all-events-inactive-tips/index.vue';
import TtamCboExternalActionNotSupportTips from './cbo-external-action-not-support-tips/index.vue';
import TtamAppEventDeepAppEventLabel from './deep-app-event-label/index.vue';
import TtamAppEventDeepAppEventLabelHint from './deep-app-event-label-hint/index.vue';
import TtamAppEventInAppEventLabel from './in-app-event-label/index.vue';
import TtamAppEventInAppEventLabelHint from './in-app-event-label-hint/index.vue';
import TtamAppEventTiktokWarningTips from './tiktok-warning-tips/index.vue';

import * as hooks from './hooks';
export default {
  TtamAppEventExternalActionSelect,
  TtamAppEventAllEventsInactiveTips,
  TtamAppEventDeepAppEventLabel,
  TtamAppEventDeepAppEventLabelHint,
  TtamAppEventInAppEventLabel,
  TtamAppEventInAppEventLabelHint,
  TtamAppEventTiktokWarningTips,
  TtamCboExternalActionNotSupportTips,
  ...hooks,
};
